export function renderChildren(node) {
  if (node == null || typeof node == 'boolean') {
    return null;
  }

  // Workaround for https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18051
  return node;
}